<template>
  <div class="multi-select" :class="[placement === 'inner' ? 'multi-select-inner' : 'multi-select-outer']">
    <!-- <span class="multi-select-dsc">环境切换</span> -->
    <kye-select class="multi-select-system" popper-class="multi-select-system-popper" @clear="clearSystem" @change="changeSystem" v-model="systemName" placeholder="请选择产品线">
      <kye-option
        v-for="item in systemList"
        :key="item.productLine"
        :label="item.productLine"
        :value="item.productLine"
      >
      </kye-option>
    </kye-select>
    <div class="multi-select-separator"></div>
    <kye-select class="multi-select-version" popper-class="multi-select-system-popper" @clear="clearVersion" :disabled="isDisabledVersion" v-model="versionId" placeholder="请选择环境" @change="changeVersion">
      <kye-option
        v-for="item in envList"
        :key="item.envId"
        :label="item.envName"
        :value="item.envId"
      >
      </kye-option>
    </kye-select>
  </div>
</template>
<script>
  import { setMultiModuleData, MULTISESSIONKEY } from '@/layout/utils'
  export default {
    props: {
      placement: { // 放置位置：outer-在casLogin； inner-在header
        type: String,
        default: 'outer'
      }
    },
    data() {
      return {
        systemList: [],
        systemName: '默认环境',
        envList: [],
        versionId: ''
      }
    },
    mounted() {
      this.getListInfo()
    },
    computed: {
      isDisabledVersion() {
        return this.systemName === '默认环境'
      }
    },
    methods: {
      // 获取环境下拉数据
      async getListInfo() {
        try {
          const defalutVsersion = {
            productLine: '默认环境',
            envList: []
          }
          const data = await this.$http('fmk.virtualEnv.list', {
            clientType: 10,
            time: Date.now()
          }, { appkey: '55111' })
          this.systemList = [defalutVsersion, ...data]
          this.initMultiData()
        } catch (error) {
          console.log('error', error)
        }
      },
      // 初始化默认数据
      initMultiData() {
        try {
          const multiSessionStr = sessionStorage.getItem('ERPMULTIMODULE')
          if (multiSessionStr) {
            const multiSessionData = JSON.parse(multiSessionStr)
            this.systemName = multiSessionData.systemName
            this.envList = this.systemList.find(i => i.productLine === this.systemName).envList
            const versionData = this.envList && this.envList.find(i => i.envId === multiSessionData.envId)
            if (versionData) {
              this.versionId = multiSessionData.envId
            } else {
              this.versionId = ''
              this.clearVersion()
            }
          }
        } catch (err) {
          console.error('initMultiData', err)
        }
      },
      // 选择环境，存储session
      changeVersion(val) {
        try {
          const selectVersion = this.envList.find(i => i.envId === val)
          const versionModule = {
            systemName: this.systemName, // 系统名称: 基础服务
            systemCode: selectVersion.module, // 前端产品线: sys、crm、tms
            version: selectVersion.resourcePath, // 多版本远程包夹子: remote-module-sys1
            envId: selectVersion.envId, // 多版本环境id
            envName: selectVersion.envName // 多版本环境名称
          }
          setMultiModuleData(versionModule)
          window.__intercept__ = 0
          location.reload()
        } catch (err) {
          console.error('changeVersion', err)
        }
      },
      clearSystem() {
        this.versionId = ''
        this.envList = []
      },
      clearVersion() {
        sessionStorage.removeItem(MULTISESSIONKEY)
      },
      changeSystem(val) {
        sessionStorage.removeItem(MULTISESSIONKEY)
        if (!val) {
          window.__intercept__ = 0
          location.reload()
          return
        }
        const selectSystem = this.systemList.find(i => i.productLine === val)
        this.envList = selectSystem.envList
        this.versionId = ''
        if (val === '默认环境') {
          window.__intercept__ = 0
          location.reload()
        }
      }
    }
  }
</script>
<style lang="scss" scoped>
.multi-select {
  position: absolute;
  top: 4px;
  right: 120px;
  height: 28px;
  display: flex;
  align-items: center;
  &.multi-select-outer {
    background: #fff;
    border-radius: 6px;
    height: 32px;
    top: 12px;
    right: 208px;
    .multi-select-system {
      width: 98px;
      /deep/ {
        .el-input__inner {
          color: #1D1C23;
        }
      }
    }
    .multi-select-version {
      width: 108px;
      /deep/ {
        .el-input__inner {
          color: #1D1C23;
          &::placeholder {
            color: #9D9CA4;
          }
        }
      }
    }
    .multi-select-separator {
      background: rgba(0, 0, 0, 0.1);
    }
  }
  &.multi-select-inner {
    position: relative;
    height: 100%;
    left: 0;
    top: 0
  }
  &-dsc {
    color: #fff;
  }
  &-system {
    width: 120px;
    /deep/ {
      .el-input__suffix {
        right: 12px;
      }
      .el-input__inner {
        color: var(--g-theme-header-action-color-text);
        padding: 0 12px;
        padding-right: 30px;
        border: none;
        background: transparent;
        &::placeholder {
          color: var(--g-theme-placeholder-dark-color);
        }
      }
    }
  }
  &-separator {
    width: 1px;
    height: 10px;
    background: var(--g-theme-divider);
  }
  &-version {
    width: 140px;
    /deep/ {
      .el-input__inner {
        color: var(--g-theme-header-action-color-text);
        padding: 0 12px;
        padding-right: 32px;
        border: none;
        background: transparent;
        &::placeholder {
          color: var(--g-theme-placeholder-dark-color);
        }
      }
      .el-input__suffix {
        right: 12px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/components/multi-module-select.vue